<template>
    <section class="flex font-poppins md:flex-col">
        <div>
            <AdminDashboardNav/>
        </div> 
        <div class=" w-screen pl-10 pr-10 md:p-2">
            <section class="mt-6">
                <div class=" flex justify-between md:flex-col-reverse">
                    <div>
                        <GetDate/>
                        <p class="text-blue-700 font-bold text-2xl md:text-xl">MANAGE CARRIERS</p>
                    </div>

                    <div class=" mr-10">
                        <Notification/>
                    </div>
                </div>
            </section>
            
            <div class="mb-10 mt-20 md:m-3">
                <div class="flex">
                    <i class="fa fa-arrow-left mt-1 text-blue-700"></i>
                    <button class="text-sm ml-4 text-blue-700 cursor-pointer" @click="goBack" >Go Back</button>
                    <p class=" ml-8 font-semibold text-lg md:text-sm">Carrier's Information</p>
                    <i v-if="isLoading" class="fa  fa-spinner fa-spin  ml-4 text-blue-600"></i>    
                </div>
            </div>
            <div @click="triggerReady">TRIGGER MAP</div>
            
            <section class="flex justify-between md:flex-col md:text-sm">
                <div class=" flex">
                    <img src="../assets/customer-pic1.png" alt="pic">
                    <button class="mt-4 cursor-pointer rounded-2xl ml-6  border-blue-400 text-center p-2 bg-green-100 text-green-300 font-semibold" >
                            <span v-if="rider.status === 'approved' " class="pl-4 pr-4 text-yellow-600" @click="blockRider(rider)">Block</span>
                            <span v-if="rider.status === 'blocked' " class="pl-4 pr-4 text-yellow-600" @click="unblockRider(rider)">Unblock</span>
                            <span v-if="rider.status === 'pending' " class="pl-4 pr-4" style=" color: rgb(243, 243, 9);">Pending</span>

                    </button>
                    <div class="flex ml-6 border bg-gray-200 p-2  text-center mt-4 rounded-xl cursor-pointer">
                        <img class="w-5 h-5 mr-2" src="../assets/message-icon.png"/>
                        <p><router-link :to="{name: 'email-center'}">Send Email</router-link> </p>
                    </div>
                </div>

                <div class="text-right md:mt-3">
                    <button @click="deleteRiderModal(rider)" class="bg-red-100 text-red-600 rounded-xl p-2"><i class="fa fa-trash mr-2"></i>Delete</button>
                </div>
            </section>

            <section class="flex justify-between  mt-6 text-blue-600">
                <div class="flex">
                    <i class="fa fa-user-o fa-2x"></i>
                    <p class="ml-6 mt-3">Profile Details</p>
                </div>
               
                <div class="flex">
                     <p @click="edit" class="cursor-pointer mt-6 border-b border-gray-200">Edit Profile</p>
                    <p @click="setSelectedTab('rider-activities')" :class="{active: selectedTab === 'rider-activities'}"  class=" cursor-pointer mt-6 border-b border-gray-200 ml-20">Activity</p>
                    <p @click="setSelectedTab('rider-analytics')" :class="{active: selectedTab === 'rider-analytics'}"  class="cursor-pointer mt-6 border-b border-gray-200 ml-20">Analytics</p>
                     <p @click="setSelectedTab('attachment')" :class="{active: selectedTab === 'user-activity'}"  class="cursor-pointer mt-6 border-b border-gray-200 ml-20">Attachments</p>
                </div>
               
            </section>
            <hr>

            <section class="flex justify-between md:flex-col">

                <div class="mt-6">
                        <div>
                            <div>
                                <div class="flex">
                                    <p> Status: </p>
                                    <p class="ml-10 text-blue-600">{{rider.status}}.</p>
                                </div>
                                <div class="flex mt-4">
                                    <p > Name: </p>
                                    <p class="ml-10 text-blue-600">{{rider.firstName}}  {{rider.lastName}}.</p>
                                </div>
                                 <div class="flex mt-4">
                                    <p > Email: </p>
                                    <p class="ml-10 text-blue-600">{{rider.email}}</p>
                                </div>
                                <div class="flex mt-4">
                                    <p >Phone Number:</p>  
                                    <p class="ml-10 text-blue-600">{{rider.phone}}.</p>
                                </div>
                                <div v-show="rider.vehicleType" class="flex mt-4">
                                    <p >Vehicle Type:</p>  
                                    <p class="ml-10 text-blue-600">{{rider.vehicleType}}.</p>
                                </div>
                                <div v-show="rider.vehicleModel" class="flex mt-4">
                                    <p >Vehicle Model:</p>  
                                    <p class="ml-10 text-blue-600">{{rider.vehicleModel}}.</p>
                                </div>
                                <div v-show="rider.vehicleYear" class="flex mt-4">
                                    <p >Vehicle Year:</p>  
                                    <p class="ml-10 text-blue-600">{{rider.vehicleYear}}.</p>
                                </div>
                                <div v-show="rider.licenseNumber" class="flex mt-4">
                                    <p >Plate Number:</p>  
                                    <p class="ml-10 text-blue-600">{{rider.licenseNumber}}.</p>
                                </div>
                                <div v-show="rider.chasisNumber" class="flex mt-4">
                                    <p >Chasis Number:</p>  
                                    <p class="ml-10 text-blue-600">{{rider.chasisNumber}}.</p>
                                </div>
                                <div v-show="rider.engineNumber" class="flex mt-4">
                                    <p >Engine Number:</p>  
                                    <p class="ml-10 text-blue-600">{{rider.engineNumber}}.</p>
                                </div>
                                <div v-show="rider.uniqueId" class="flex mt-4">
                                    <p >Unique ID:</p>  
                                    <p class="ml-10 text-blue-600">{{rider.uniqueId}}.</p>
                                </div>
                            </div>

                        </div>


                    </div>  

                 <div>
                    <EditRiderInfo v-show="editProfile" @getRider="getRider" />
                </div>           
                <component :is="selectedTab"></component> 
            </section>   
               <button class="bg-blue-700 p-1 text-white rounded text-sm" @click="triggerReady">
                        Click here to Load Map
                    </button>
                        <place-search
                            v-bind:ready="ready"
                            placeholder="Enter a location"
                            loading="Map is loading"
                            v-bind:gps_timeout="7000"
                            v-bind:fallbackProcedure="fallbackProcedure"
                            v-bind:zoom="zoom"
                            v-bind:geolocation="geolocation"
                            v-bind:address="address"
                            v-bind:manually="manually"
                            @changed="getMapData"
                        >
                        </place-search> 
            
           
            
        </div> 

        <div>
            <DeleteModal
            v-show="deleteModal"
            @close="closeModal"
            :message="message"
            @getRiders="getRider"
            :riderId="riderId"
            />
        </div>         
    </section>
</template>

<script>
import axios from 'axios';
import AdminDashboardNav from '../AdminDashboardNav.vue';
import GetDate from '../GetDate.vue';
import Notification from '../Notification.vue';
import RiderAnalytics from './RiderAnalytics.vue';
import RiderActivities from './RiderActivities.vue';
import Attachment from './Attachment.vue';
import DeleteModal from './DeleteModal.vue';
import EditRiderInfo from './EditRiderInfo'
import moment from 'moment';
import PlaceSearch from '../Orders/PlaceSearch.vue';
import {baseUrl} from '../../../Config';
const url = baseUrl;
export default {
    props: ['id'],

    components : {
        AdminDashboardNav,
        GetDate,
        Notification,
        RiderAnalytics,
        RiderActivities,
        Attachment,
        PlaceSearch,
        EditRiderInfo,
        DeleteModal
    },

    data() {
        return {
            selectedTab: 'rider-analytics',
            riderInfo: true,
            pendingRiders: true,
            rider: [],
            isLoading: false,
            lat: "",
            lng: "",
            isActive: false,
            blockStatus : "blocked",
            unblockStatus : "approved",
             deleteModal: false,
            message: "",
            riderId: "",
            ready: false, //Add ready:false to stop map from loading, and then when changed to true map will auto load
            fallbackProcedure: "gps", //gps | geolocation | address | manually
            zoom: 17, //Default Zoom
            geolocation: {
                // If GPS and Find by address fails then, map will be positioned by a default geolocation
                lat: parseFloat(this.lat),
                lng: parseFloat(this.lng),
                zoom: 2,
            },
            address: {
                query: "Nigeria", //If GPS fails, Find by address is triggered
                zoom: 10,
            },
           manually: {
                // address_description: "Nigeria",
                // city: "Nigeria",
                // country: "Nigeria",
                lat: 41.3267905,
                lng: 19.8060475,
                // state: "Nigeria",
                // zip_code: "",
                zoom: 17,
            },
            place: {},
            form_data: {},
            editProfile: false
        }
    },

    mounted() {
        this.getRider();
        this.networkError();
        this.triggerReady();
    },

    methods: {
        setSelectedTab(tab) {
            this.selectedTab = tab;
        },
        moment(date) {
            return moment(date);
        },
        edit() {
            this.editProfile = !this.editProfile;
        },

        closeModal() {
            this.deleteModal = false;
        },
        deleteRiderModal(rider) {
            this.riderId = rider._id
            this.deleteModal = true;
            this.message =  "Are you sure you want to perform this action?"
        },

        getMapData(place) {
            this.place = place;
            console.log(this.place);
            },
            triggerReady() {
            this.fallbackProcedure = "manually";
            this.ready = true;
        },

        goBack() {
            this.$router.go(-1)
        },

        getRider() {
             this.$store.commit("riderEmail", this.id);
             this.isLoading = true
            axios({
                method: 'GET',
                url: `${url}/v1/web/riders/check/${this.id}`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: 'Bearer' + localStorage.getItem("token"),
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response)=> {
                this.rider = response.data.data
                this.isLoading = false
                let lat = this.rider.lastLat;
                let lng = this.rider.lastLng;
                console.log(this.rider);
                console.log("lat", lat, "lng", lng);
                
                
            })
            .catch((error) => {
                console.log(error)
            })
        },

        blockRider(rider) {
            axios({
                method: 'PUT',
                url: `${url}/v1/web/riders/update/status/${rider._id}`,
                headers: {
                    Authorization: 'Bearer' + localStorage.getItem('token'),
                    'Content-type': 'application/json',
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
                data : {
                    status : this.blockStatus
                }
            })
            .then((response) => {
                this.getRider()
                response;
            }) 
            .catch((error) => {
                console.log(error)
            })
        },

        unblockRider(rider) {
            axios({
                method: 'PUT',
                url: `${url}/v1/web/riders/update/status/${rider._id}`,
                headers: {
                    Authorization: 'Bearer' + localStorage.getItem('token'),
                    'Content-type': 'application/json',
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
                data : {
                    status : this.unblockStatus
                }
            })
            .then((response) => {
                this.getRider()
                response;
            }) 
            .catch((error) => {
                console.log(error)
            })
        },


        networkError() {
            if(!navigator.onLine) {
                this.$router.push('/network-error')
            } 
        }
    }
}
</script>

